const list = {
  path: 'list',
  component: resolve => require(['@/pages/admin/merchant/list'], resolve),
  meta: {
    requireAuth: true
  }
}

export default list